/* ====================== WISHLIST JS - JFASHION1 v3.1 ====================== */

(function() {
  'use strict';

  // ===== Prevent duplicate initialization =====
  if (window.__jfashionWishlistReady) return;
  window.__jfashionWishlistReady = true;

  // ===== Constants =====
  const WISHLIST_KEY = 'jfashion_wishlist_v3';
  const MAX_ITEMS = 100;
  const CLICK_DEBOUNCE = 300; // ms

  // ===== Localization =====
  const STRINGS = {
    ar: {
      added: 'تمت الإضافة إلى المفضلة',
      removed: 'تمت الإزالة من المفضلة',
      error: 'حدث خطأ',
      maxReached: 'المفضلة ممتلئة ({{max}} منتجات)',
      loginRequired: 'سجّلي الدخول لحفظ المفضلة'
    },
    en: {
      added: 'Added to wishlist',
      removed: 'Removed from wishlist',
      error: 'An error occurred',
      maxReached: 'Wishlist full ({{max}} items)',
      loginRequired: 'Login to save your wishlist'
    }
  };

  function getLang() {
    return document.documentElement.lang?.startsWith('ar') ? 'ar' : 'en';
  }

  function t(key, vars) {
    let text = STRINGS[getLang()]?.[key] || STRINGS.en[key] || key;
    if (vars) {
      Object.keys(vars).forEach(function(k) {
        text = text.replace('{{' + k + '}}', vars[k]);
      });
    }
    return text;
  }

  // ===== Storage =====
  function getWishlist() {
    try {
      const data = localStorage.getItem(WISHLIST_KEY);
      if (!data) return [];
      const parsed = JSON.parse(data);
      if (!Array.isArray(parsed)) {
        // Corrupted data - clear it
        localStorage.removeItem(WISHLIST_KEY);
        return [];
      }
      return parsed.filter(function(item) { return item && item.handle; });
    } catch(e) {
      console.warn('Wishlist: Failed to read storage', e);
      // Clear corrupted data
      try { localStorage.removeItem(WISHLIST_KEY); } catch(e2) {}
      return [];
    }
  }

  function saveWishlist(wishlist) {
    try {
      if (!Array.isArray(wishlist)) return false;
      const limited = wishlist.slice(0, MAX_ITEMS);
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(limited));
      window.dispatchEvent(new CustomEvent('wishlist:updated', {
        detail: { count: limited.length, items: limited }
      }));
      return true;
    } catch(e) {
      console.warn('Wishlist: Failed to save storage', e);
      // Storage full or quota exceeded
      showToast(t('error'), 'error');
      return false;
    }
  }

  // ===== Toast =====
  function showToast(message, type) {
    // Use global toast if available
    if (window.showToast && typeof window.showToast === 'function') {
      window.showToast(message, type);
      return;
    }

    // Remove existing toast
    const existing = document.querySelector('.wishlist-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'wishlist-toast wishlist-toast--' + (type || 'success');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');

    const icon = document.createElement('span');
    icon.setAttribute('aria-hidden', 'true');
    icon.style.fontSize = '18px';
    icon.textContent = type === 'error' ? '⚠️' : '✅';

    const text = document.createElement('span');
    text.textContent = message;

    toast.appendChild(icon);
    toast.appendChild(text);
    document.body.appendChild(toast);

    setTimeout(function() {
      toast.classList.add('is-hiding');
      setTimeout(function() {
        if (toast.parentNode) toast.remove();
      }, 300);
    }, 3000);
  }

  // ===== Update UI =====
  function updateButtons() {
    const wishlist = getWishlist();
    const handles = new Set(wishlist.map(function(item) { return item.handle; }));

    document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn) {
      try {
        const data = JSON.parse(btn.dataset.productData || '{}');
        const isActive = handles.has(data.handle);

        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', String(isActive));

        // Update aria-label
        const action = isActive ? t('removed') : t('added');
        btn.setAttribute('aria-label', action + ': ' + (data.title || ''));
      } catch(e) {
        console.warn('Wishlist: Invalid button data', e);
      }
    });

    // Update count badges
    document.querySelectorAll('[data-wishlist-count]').forEach(function(badge) {
      badge.textContent = wishlist.length;
      badge.hidden = wishlist.length === 0;
      if (wishlist.length > 0) {
        badge.classList.add('is-active');
        setTimeout(function() { badge.classList.remove('is-active'); }, 300);
      }
    });

    // Update header icon
    const headerIcon = document.getElementById('header-wishlist-icon');
    if (headerIcon) {
      const hasItems = wishlist.length > 0;
      headerIcon.style.fill = hasItems ? '#e11d48' : 'none';
      headerIcon.style.stroke = hasItems ? '#e11d48' : 'currentColor';
    }
  }

  // ===== Toggle with debounce =====
  let clickTimestamps = new Map();

  function toggleWishlist(btn) {
    const btnId = btn.dataset.productId || btn.dataset.productData;
    const now = Date.now();

    // Debounce
    if (clickTimestamps.has(btnId)) {
      const lastClick = clickTimestamps.get(btnId);
      if (now - lastClick < CLICK_DEBOUNCE) return;
    }
    clickTimestamps.set(btnId, now);

    try {
      const data = JSON.parse(btn.dataset.productData || '{}');
      if (!data.handle) return;

      let wishlist = getWishlist();
      const exists = wishlist.some(function(item) { return item.handle === data.handle; });

      if (exists) {
        // Remove
        wishlist = wishlist.filter(function(item) { return item.handle !== data.handle; });
        if (saveWishlist(wishlist)) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
          showToast(t('removed') + ': ' + data.title, 'success');
        }
      } else {
        // Add
        if (wishlist.length >= MAX_ITEMS) {
          showToast(t('maxReached', {max: MAX_ITEMS}), 'error');
          return;
        }

        data.addedAt = new Date().toISOString();
        wishlist.push(data);

        if (saveWishlist(wishlist)) {
          btn.classList.add('is-active');
          btn.classList.add('is-animating');
          btn.setAttribute('aria-pressed', 'true');
          setTimeout(function() { btn.classList.remove('is-animating'); }, 400);
          showToast(t('added') + ': ' + data.title, 'success');
        }
      }

      updateButtons();
    } catch(e) {
      console.error('Wishlist toggle error:', e);
      showToast(t('error'), 'error');
    }
  }

  // ===== Event delegation =====
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(btn);
  }, true);

  // ===== Initialize =====
  function init() {
    updateButtons();

    window.addEventListener('wishlist:updated', updateButtons);
    window.addEventListener('pageshow', updateButtons);

    // Expose API
    window.jfashionWishlist = {
      get: getWishlist,
      add: function(data) {
        const wishlist = getWishlist();
        if (!wishlist.some(function(item) { return item.handle === data.handle; })) {
          wishlist.push(Object.assign({}, data, { addedAt: new Date().toISOString() }));
          saveWishlist(wishlist);
        }
      },
      remove: function(handle) {
        const wishlist = getWishlist().filter(function(item) { return item.handle !== handle; });
        saveWishlist(wishlist);
      },
      clear: function() { saveWishlist([]); },
      count: function() { return getWishlist().length; },
      isInWishlist: function(handle) {
        return getWishlist().some(function(item) { return item.handle === handle; });
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();